module.exports = () => {
  return {
    all: [],
    catering: [],
    searched: false,
    address: null,
    position: {
      lat: 0,
      lng: 0,
    },
    results: [],
    deliveryAddress: null,
    vehicleInfo: null,
    resultsTab: 'Nearby',
    selectedState: null,
    searchType: 'pickup',
    tableposref: null
  }
}
